import mod from "-!./place-input.js?vue&type=script&lang=js&"; export default mod; export * from "-!./place-input.js?vue&type=script&lang=js&"